import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { LanguageType } from '../shared/types';

@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.scss'],
})
export class AudioPlayerComponent implements OnInit, OnChanges, OnDestroy {
  @Input() source = '';
  @Input() title = '';
  @Input() imgSrc = '';
  @Input() language: LanguageType = 'hebrew';

  @Output() videoEndedEvent = new EventEmitter<void>();

  isPlaying = false;
  /** Audio source duration in seconds. */
  duration = 0;
  /** Current time of the audio. */
  time = 0;

  player = new Audio();

  onLoadingData = (event) => {
    this.duration = this.player.duration;
    // this.cdr.detectChanges();
  }

  onEndPlaying = () => {
    this.videoEndedEvent.emit();
  }

  onTimeChange = () => {
    this.time = this.player.currentTime;
  }

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['source']) {
      this.time = 0;
      this.isPlaying = false;
      removeEventListener('progress', this.onLoadingData, false);
      removeEventListener('loadeddata', this.onLoadingData, false);
      removeEventListener('ended', this.onEndPlaying, false);
      removeEventListener('timeupdate', this.onTimeChange, false);
      this.player.src = this.source;
      this.player.addEventListener('progress', this.onLoadingData);
      this.player.addEventListener('loadeddata', this.onLoadingData);
      this.player.addEventListener('ended', this.onEndPlaying);
      this.player.addEventListener('timeupdate', this.onTimeChange);
    }
  }

  ngOnDestroy() {
    this.player.remove();
    removeEventListener('loadeddata', this.onLoadingData, false);
    removeEventListener('ended', this.onEndPlaying, false);
    removeEventListener('timeupdate', this.onTimeChange, false);
  }

  playPause(): void {
    if (this.duration <= 0) {
      return;
    }
    this.isPlaying = !this.isPlaying;
    if (this.isPlaying) {
      this.player.play();
    } else {
      this.player.pause();
    }
  }

  pauseAudio(): void {
    if (this.duration <= 0) {
      return;
    }
    this.player.pause();
    this.isPlaying = false;
  }

  skipForward(event$: MouseEvent, seconds: number): void {
    if (this.duration <= 0) {
      return;
    }
    event$.preventDefault();
    event$.stopImmediatePropagation();
    this.time = Math.min(this.time + seconds, this.duration);
    this.setCurrentTime();
  }

  skipBackward(event$: MouseEvent, seconds: number): void {
    if (this.duration <= 0) {
      return;
    }
    event$.preventDefault();
    event$.stopImmediatePropagation();
    this.time = Math.max(this.time - seconds, 0);
    this.setCurrentTime();
  }

  formatLabel(value: number): string {
    const roundVal = Math.round(value);
    const min = Math.floor(roundVal / 60).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping: false});
    const sec = (roundVal % 60).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping: false});
    return `${min}:${sec}`;
  }

  setCurrentTime(): void {
    if (!this.player || this.duration <= 0) {
      return;
    }
    console.log('time changed');
    this.player.currentTime = this.time;
  }
}
